/** @format */
import React, { useEffect } from 'react';
import { DatePicker, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { setStartDate, setEndDate } from 'state/slice/dropDownSlice';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { RangePicker } = DatePicker;

const DateRangePicker = () => {
  const dispatch = useDispatch();

  const handleDateChange = (dates) => {
    if (Array.isArray(dates) && dates.length === 2) {
      const [start, end] = dates;
      const startDate = dayjs(start)
        .startOf('day')
        // Use the utcOffset for the selected start date
        .add(dayjs(start).utcOffset(), 'minute')
        .toISOString();
      const endDate = dayjs(end)
        .endOf('day')
        // Use the utcOffset for the selected end date
        .add(dayjs(end).utcOffset(), 'minute')
        .toISOString();

      //console.log('Adjusted Start Date:', startDate);
     // console.log('Adjusted End Date:', endDate);

      dispatch(setStartDate({ startDate }));
      dispatch(setEndDate({ endDate }));
    } else {
      // Fallback to today's date if no dates are selected.
      const today = dayjs();
      const todayStart = today
        .startOf('day')
        .add(today.utcOffset(), 'minute')
        .toISOString();
      const todayEnd = today
        .endOf('day')
        .add(today.utcOffset(), 'minute')
        .toISOString();

     // console.log('Today Adjusted Start:', todayStart);
     // console.log('Today Adjusted End:', todayEnd);

      dispatch(setStartDate({ startDate: todayStart }));
      dispatch(setEndDate({ endDate: todayEnd }));
    }
  };

  // Initialize with today's start and end if the component mounts.
  useEffect(() => {
    const today = dayjs();
    const todayStart = today
      .startOf('day')
      .add(today.utcOffset(), 'minute')
      .toISOString();
    const todayEnd = today
      .endOf('day')
      .add(today.utcOffset(), 'minute')
      .toISOString();
    dispatch(setStartDate({ startDate: todayStart }));
    dispatch(setEndDate({ endDate: todayEnd }));
  }, [dispatch]);

  return (
    <Space>
      <RangePicker onChange={handleDateChange} />
    </Space>
  );
};

export default DateRangePicker;


